import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const CarDoorIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M11.0986 4.87793C10.4144 4.87793 9.78106 5.21393 9.33087 5.66412L9.32348 5.67151L4.1997 11.1613L4.19134 11.1711C3.73455 11.704 3.49768 12.33 3.49768 13.0262V18.8637H19.9158V4.87793H11.0986ZM18.2758 17.2237H5.13763V12.8204H18.2758V17.2237H18.2758ZM18.2758 11.1798H6.42554L10.4906 6.82373C10.6792 6.63513 10.9122 6.51794 11.0986 6.51794H18.2758V11.1798ZM8.79004 13.7062H6.38965V15.3468H8.79004V13.7062Z" />
    </SvgIcon>
  );
});
